import { motion } from "framer-motion";
import { EnhancedWeatherCards } from "../EnhancedWeatherCards";
import { PrecipitationHistory } from "../PrecipitationHistory";
import { HourlyConfidenceChart } from "../HourlyConfidenceChart";

export function AccuracyInsightsSection({ item, weather, location, isPremium, isWidgetVisible, isDarkMode }) {
  return (
    <>
      {weather && location && (
        <motion.div variants={item} className="col-span-1 md:col-span-2 row-span-2 glass rounded-3xl p-4 md:p-5" data-testid="weather-details-card">
          <h3 className="font-semibold mb-4 text-white/80">Weather Details — Tap any card for depth</h3>
          <EnhancedWeatherCards lat={location.lat} lon={location.lon} isDarkMode={isDarkMode} />
        </motion.div>
      )}

      {isPremium && location && isWidgetVisible('precip-history') && (
        <motion.div variants={item} className="col-span-1 md:col-span-2 row-span-2 glass rounded-3xl p-4 md:p-5" data-testid="precipitation-history-card">
          <PrecipitationHistory lat={location.lat} lon={location.lon} isDarkMode={isDarkMode} />
        </motion.div>
      )}

      {isPremium && location && isWidgetVisible('forecast-confidence') && (
        <motion.div variants={item} className="col-span-1 md:col-span-2 row-span-2 glass rounded-3xl p-4 md:p-5" data-testid="forecast-confidence-card">
          <HourlyConfidenceChart lat={location.lat} lon={location.lon} isDarkMode={isDarkMode} />
        </motion.div>
      )}
    </>
  );
}